import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accepted: false,
  analyticsEnabled: false,
  gtmEnabled: false,
};

const cookieAcceptanceSlice = createSlice({
  name: 'cookieAcceptance',
  initialState,
  reducers: {
    acceptCookies: (state) => {
      state.accepted = true;
      state.analyticsEnabled = true;
      state.gtmEnabled = true;
    },
    declineCookies: (state) => {
      state.accepted = true;
      state.analyticsEnabled = false;
      state.gtmEnabled = false;
    },
    setAnalyticsEnabled: (state, action) => {
      state.analyticsEnabled = action.payload;
    },
    setGTMEnabled: (state, action) => {
      state.gtmEnabled = action.payload;
    },
    updateCookiePreferences: (state, action) => {
      state.analyticsEnabled = action.payload.analyticsEnabled;
      state.gtmEnabled = action.payload.gtmEnabled;
    },
  },
});

export const { 
  acceptCookies, 
  declineCookies, 
  setAnalyticsEnabled, 
  setGTMEnabled,
  updateCookiePreferences 
} = cookieAcceptanceSlice.actions;

export default cookieAcceptanceSlice.reducer;
